import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';
import { useEffect, useRef, useState } from 'react';
import useToggle from '../../hooks/useToggle';

export default () => {
  const [showMenu, toggleShowMenu] = useToggle(false);
  const bodyRef = useRef<HTMLDivElement | null>(null);
  const [lastLocked, setLastLocked] = useState<HTMLDivElement | null>(null);
  const breakpoint = 899;

  /**
   * @desc Disable scrolling when the dropdown is open on Mobile view only.
   */
  useEffect(() => {
    if (bodyRef?.current && window.innerWidth <= breakpoint && showMenu) {
      disableBodyScroll(bodyRef.current);
      setLastLocked(bodyRef.current);
    }

    const handleClickOutside = (event: MouseEvent) => {
      if (bodyRef.current && !bodyRef.current.contains(event.target as Node) && showMenu) {
        toggleShowMenu();
        document.removeEventListener('click', handleClickOutside, true);
      }
    };

    if (showMenu) {
      document.addEventListener('click', handleClickOutside, true);
    }

    if (!showMenu && !!lastLocked) {
      enableBodyScroll(lastLocked);
    }

    return () => {
      document.removeEventListener('click', handleClickOutside, true);

      if (lastLocked) {
        enableBodyScroll(lastLocked);
      }
    };
  }, [showMenu]);

  return {
    showMenu,
    toggleShowMenu,
    bodyRef,
  };
};
